<template>
    <div class="teofly_table_block">
        <div class="layer_header">
            <div v-if="current_layer.layer.name != ''" class="layer_header_with_buttons">
                <span class="layer_name layer_title">
                    <v-select
                        :items="current_project.layers"
                        v-model="select"
                        item-value="id"
                        item-text="name"
                        solo
                        :menu-props="{ offsetY: true }"
                        @change="layer_select(select)"
                    ></v-select>
                </span>

                <v-spacer></v-spacer>

                <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn fab dark x-small v-bind="attrs" v-on="on" @click="editLayerOpen()" class="green mr-2" title="Edit Layer"><i class="v-icon mdi mdi-square-edit-outline"></i></v-btn>
                    </template>
                    <span>Edit Layer</span>
                </v-tooltip>

                <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn fab dark x-small v-bind="attrs" v-on="on" @click="removeLayerOpen()" class="red" title="Delete Layer"><i class="v-icon mdi mdi-delete-empty-outline"></i></v-btn>
                    </template>
                    <span>Delete Layer</span>
                </v-tooltip>

            </div>
            <h5 v-else>Select Layer to View</h5>
        </div>

        <v-dialog v-model="dialog_layer_edit" width="500" dark overlay-opacity=".5" overlay-color="#333">
            <v-card>
                <v-card-title class="headline dark justify-center">
                    Please, enter layer name
                </v-card-title>
                <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="editNewLayer">
                    <v-card-text>
                        <v-col cols="12">
                            <v-text-field v-model="newLayerName" :rules="nameRules" label="Layer Name" hint="Please enter layer name" required></v-text-field>
                        </v-col>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions >
                        <v-spacer></v-spacer>
                        <v-btn color="teofly_orange" text dark type="submit">Save</v-btn>
                        <v-btn color="grey" text dark @click="dialog_layer_edit = false">Cancel</v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialog_layer_remove" width="500" dark overlay-opacity=".5" overlay-color="#333">
            <v-card>
                <v-card-title class="headline dark justify-center">
                    Are you sure to delete this layer?
                </v-card-title>
                <v-divider></v-divider>
                <v-card-actions class="justify-center">
                    <v-btn color="teofly_yes_button" dark @click="deleteLayer">Yes</v-btn>
                    <v-btn color="teofly_no_button" dark @click="dialog_layer_remove = false">No</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <vue-easy-lightbox
            :visible="visible"
            :imgs="imgs"
            @hide="handleLBHide"
        ></vue-easy-lightbox>

        <v-dialog v-model="dialog_map" width="700" dark overlay-opacity=".5" overlay-color="#333">
            <div class="dialog_map" id="dialog_map"></div>
        </v-dialog>

        <v-dialog v-model="dialog_remove" width="500" dark overlay-opacity=".5" overlay-color="#333">
            <v-card>
                <v-card-title class="headline dark justify-center">
                    Are you sure to delete this document?
                </v-card-title>
                <v-divider></v-divider>
                <v-card-actions class="justify-center">
                    <v-btn color="teofly_yes_button" dark @click="deleteDocument">Yes</v-btn>
                    <v-btn color="teofly_no_button" dark @click="dialog_remove = false">No</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog
            v-model="dialog_edit"
            width="600"
            dark
            overlay-opacity=".5"
            overlay-color="#333"
        >
            <v-card>
                <v-card-title class="headline dark justify-center">
                    Edit Document
                </v-card-title>
                <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="updateNewDocument">
                    <v-card-text>
                        <v-col cols="12">
                            <v-text-field v-model="documentLat" :rules="nameRules" label="Document Latitude" hint="Please enter Latitude" required></v-text-field>
                            <v-text-field v-model="documentLng" :rules="nameRules" label="Document Longitude" hint="Please enter Longitude" required></v-text-field>
                            <v-text-field v-model="documentHeading" :rules="nameRules" label="Document North Offcet" hint="Please enter Noth Offcet" required></v-text-field>
                            <v-text-field v-model="documentLabel" label="Document Label" hint="Please enter Label"></v-text-field>
                        </v-col>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions >
                        <v-spacer></v-spacer>
                        <v-btn color="teofly_orange" text dark type="submit">Update Document</v-btn>
                        <v-btn color="grey" text dark @click="dialog_edit = false">Cancel</v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>

        <v-data-table
            :headers="headers"
            :items="current_layer.documents"
            :sort-by="'id'"
            class="responsive-table teofly-table"
            dark
            hide-default-footer
            :items-per-page="-1"
            :item-class= "row_classes"
        >
            <template v-slot:top>
                <div class="text-center layer_filters">
                    <label>
                        <input class="with-gap" name="filter" v-model="search" type="radio" checked  value="" />
                        <span>All</span>
                    </label>
                    <label>
                        <input class="with-gap" name="filter" v-model="search" type="radio" value="panorama" />
                        <span>Panoramas</span>
                    </label>
                    <label>
                        <input class="with-gap" name="filter" v-model="search" type="radio" value="image" />
                        <span>Images</span>
                    </label>
                    <label>
                        <input class="with-gap" name="filter" v-model="search" type="radio" value="video" />
                        <span>Video</span>
                    </label>
                </div>
            </template>

            <template v-slot:item.name="{ item }">
                <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                        <div v-bind="attrs" v-on="on" class="shortest_name">{{ item.name }}</div>
                    </template>
                    <span>{{ item.name }}</span>
                </v-tooltip>
            </template>

            <template v-slot:item.type="{ item }">
                <div class="center_image">
                    <span class="teofly_image_type">
                        <img @click="showImage(item.preview)" class="materialboxed" height="50" :src="item.thumbnail" />
                        <span class="teofly_image_type_icon">
                            <i v-if="item.type == 'image'" title="Image" class="v-icon mdi mdi-image-area"></i>
                            <i v-if="item.type == 'video'" title="Video" class="v-icon mdi mdi-youtube"></i>
                            <i v-if="item.type == 'panorama'" title="Panorama" class="v-icon mdi mdi-panorama-horizontal"></i>
                        </span>
                    </span>
                </div>
            </template>

            <template v-slot:item.size="{ item }">
                <div class="non_break_line">{{ formatBytes(item.size) }}</div>
            </template>

            <template v-slot:item.width="{ item }">
                {{ item.width }} x {{ item.height }}
            </template>

            <template v-slot:item.latitude="{ item }">
                <span title="Coordinates not available" v-if="(item.latitude == 0 && item.longitude == 0)" class="red--text"><i class="v-icon mdi mdi-alert"></i></span>
                <span v-else @click="showMap(item)" class="show_single_map">{{ convertToDMS(item.latitude, 'lat') }}<br />{{ convertToDMS(item.longitude, 'lng') }}</span>
            </template>

            <template v-slot:item.label="{ item }">
                <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                        <i v-bind="attrs" v-on="on" v-if="item.label != ''" title="Label" class="v-icon mdi mdi-comment-outline" style="font-size:20px;"></i>
                    </template>
                    <span>{{item.label}}</span>
                </v-tooltip>
            </template>

            <template v-slot:item.created_at="{ item }">
                {{ item.actual_timestamp != 0 ? connvertToHumanDate(item.actual_timestamp) : 'N/A' }}
            </template>

            <template v-slot:item.actions="{ item }">
                <div class="non_break_line">
                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn v-bind="attrs" v-on="on" @click="editItemOpen(item)" class="btn-floating btn-flat gray btn_edit_img"><i class="material-icons">tune</i></v-btn>
                        </template>
                        <span>Edit File</span>
                    </v-tooltip>

                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn v-bind="attrs" v-on="on" @click="deleteItemOpen(item)" class="btn-floating btn-flat gray btn_delete_img"><i class="material-icons">clear</i></v-btn>
                        </template>
                        <span>Delete File</span>
                    </v-tooltip>
                </div>
            </template>

            <template slot="no-data">
                No files found
            </template>

        </v-data-table>
    </div>
</template>

<script>
import VueEasyLightbox  from "vue-easy-lightbox";
import L                from 'leaflet/dist/leaflet';

export default {
    name: "LayerTable",
    data () {
        return {
            dialog_layer_edit: false,
            dialog_layer_remove: false,
            search: '',
            visible: false,
            show_tooltip:false,
            imgs: '',
            dialog_remove: false,
            documentId: 0,
            valid: false,
            dialog_edit: false,
            documentLat: 0,
            documentLng: 0,
            documentHeading: 0,
            documentLabel: '',
            nameRules: [
                v => !!v || 'Field cannot be empty'
            ],
            dialog_map: false,
            map: null,
            editLayerId: 0,
            newLayerName: '',
            items: [ ],
            select: null
        }
    },
    computed: {
        projects () {
            return this.$store.getters.projects;
        },
        current_layer () {
            return this.$store.getters.currentLayer;
        },
        current_project () {
            return this.$store.getters.currentProject;
        },
        headers () {
            return [
                { text: '#',            value: 'id',        align: 'start' },
                { text: 'Name',         value: 'name' },
                { text: 'Preview',      value: 'type',      align: 'center', filter: value =>{
                    if (!this.search) return true;
                    return value.indexOf(this.search) !== -1
                }},
                { text: 'Size',         value: 'size',      align: 'center' },
                { text: 'Resolution',   value: 'width',     align: 'center' },
                { text: 'Lat / Lng',    value: 'latitude',  align: 'center', sortable: false },
                { text: 'Label',        value: 'label',     align: 'center' },
                { text: 'Date',         value: 'created_at',align: 'center' },
                { text: '',             value: 'actions',   align: 'end' }
            ]
        }
    },
    watch: {
        current_layer () {
            this.select = this.current_layer.layer.id
        }
    },
    methods: {
        layer_select(layer){
            this.$store.dispatch('getCurrentLayer', {hashid: this.current_layer.project.hashid, id: layer});
            let prj = this.projects.find(project => project.hashid === this.current_layer.project.hashid);
            for (let layer of prj.layers){
                layer.active = false;
            }
            const key = Object.keys(prj.layers).find(k=>prj.layers[k].id==layer);
            prj.layers[key].active = true;
        },
        showMap(map){
            this.dialog_map = true;
            setTimeout(() => {

                if (this.map != null){
                    this.map.remove();;
                }

                this.map = L.map('dialog_map').setView([map.latitude, map.longitude], 17);
                L.tileLayer('https://tile.teofly.com/tile/m9/{z}/{x}/{y}', {
                    maxZoom: 20,
                    tileSize: 512,
                    zoomOffset: -1
                }).addTo(this.map);
                let myIcon = L.divIcon({
                    className: 'my-div-icon',
                    html: '<span class="marker_icon marker_icon_special_first"></span>'
                });
                L.marker([map.latitude, map.longitude], { icon: myIcon }).addTo(this.map);
            }, 100);
        },
        showImage(img) {
            this.imgs = img;
            this.showLighBox();
        },
        showLighBox() {
            this.visible = true;
        },
        handleLBHide() {
            this.visible = false;
        },
        deleteItemOpen(document){
            this.documentId = document.id;
            this.dialog_remove = true;
        },
        deleteDocument(){
            const layer = {
                hashid : this.current_layer.project.hashid,
                id: this.current_layer.layer.id
            };
            this.$store.dispatch('deleteDocument', this.documentId).then(() => {
                this.dialog_remove = false;
                this.documentId = 0;
                this.$store.dispatch('getCurrentLayer', layer);
                this.$store.dispatch('getLayers', this.current_layer.project.hashid);
                this.$store.dispatch('getUser');
            })
            .catch(() => {});
        },
        editItemOpen(document){
            this.documentId = document.id;
            this.documentLat = document.latitude;
            this.documentLng = document.longitude;
            this.documentHeading = document.north_offset;
            this.documentLabel = document.label;
            this.dialog_edit = true;
        },
        updateNewDocument (){
            if (this.$refs.form.validate()){
                const layer = {
                    hashid : this.current_layer.project.hashid,
                    id: this.current_layer.layer.id
                };
                const document = {
                    id: this.documentId,
                    latitude: this.documentLat,
                    longitude: this.documentLng,
                    heading: this.documentHeading,
                    label: this.documentLabel
                };
                this.$store.dispatch('updateDocument', document).then(() => {
                    this.dialog_edit = false;
                    this.documentId = 0;
                    this.documentLat = 0;
                    this.documentLng = 0;
                    this.documentHeading = 0;
                    this.$store.dispatch('getCurrentLayer', layer);
                })
                .catch(() => {});
            }
        },
        removeLayerOpen (){
            this.dialog_layer_remove = true;
            this.editLayerId = this.current_layer.layer.id;
        },
        deleteLayer(){
            this.$store.dispatch('deleteLayer', this.editLayerId).then(() => {
                this.dialog_layer_remove = false;
                this.$store.dispatch('getUser');
                this.$store.dispatch('getProjects')
                .then(() => {
                    const prjkey = Object.keys(this.projects).find(k=>this.projects[k].hashid===this.current_layer.project.hashid);
                    this.projects[prjkey].active = true;
                    this.$store.dispatch('clearCurrentLayer');
                    this.$store.dispatch('setCurrentProject', this.current_project.hashid);
                });
            })
            .catch(() => {});
        },
        editLayerOpen (){
                this.newLayerName = this.current_layer.layer.name;
                this.editLayerId = this.current_layer.layer.id;
                this.dialog_layer_edit = true;
        },
        editNewLayer (){
            if (this.$refs.form.validate()){
                const layer = {
                    name: this.newLayerName,
                    hashid: this.current_layer.project.hashid,
                    id: this.editLayerId
                };
                this.$store.dispatch('editNewLayer', layer)
                .then(() => {
                    this.dialog_layer_edit = false;
                    this.$refs.form.reset();
                    this.$store.dispatch('getCurrentLayer', layer);
                    this.$store.dispatch('getProjects')
                    .then(() => {
                        const prjkey = Object.keys(this.projects).find(k=>this.projects[k].hashid==this.current_layer.project.hashid);
                        const lyrkey = Object.keys(this.projects[prjkey].layers).find(k=>this.projects[prjkey].layers[k].id==this.editLayerId);
                        this.projects[prjkey].active = true;
                        this.projects[prjkey].layers[lyrkey].active = true;
                    })
                })
                .catch(() => {});
            }
        },
        row_classes(item) {
            if (item.latitude == 0 && item.longitude == 0) {
                return "warning-teofly";
            }
        }
    },
    created(){
        this.select = this.current_layer.layer.id
    }
};
</script>
